<template>
    <div>
 
        <div class="chart" id="direct" ref="chartRef" />
    </div>
</template>
  
<script>
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([GridComponent, BarChart, CanvasRenderer]);


export default {

    components: {

    },
    props: {
        chartData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            option: {},
            chartDom: null,
            myChart: null,
            colorList:['#426688','#669ED0','#FEC558']
        };
    },
    mounted() {
        console.log(this.chartData)
        this.chartDom = document.getElementById('direct');
        this.myChart = echarts.init(this.chartDom);

        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow',
                },
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                data: this.chartData.map(el => el.date)
            },
            yAxis: {
                type: 'value',
                boundaryGap: [0, '100%']
            },
            legend: {
                icon: 'circle',
                bottom: -5,
                left: 50
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100
                },

            ],
            // series: [
            //     {
            //         data: this.chartData.map(el => el.count),
            //         type: 'bar',
            //         showBackground: false,

            //         backgroundStyle: {
            //             color: 'rgba(180, 180, 180, 0.2)'
            //         }
            //     }
            // ]
        };
        let series = this.chartData.reduce((r, a) => {
            r[a.registrationType] = [...(r[a.registrationType] || []), a]
            return r
        }, {})
        this.option.series = Object.keys(series).map((el,i) => {
          
            return {
                name: el,
                type: 'bar',
                stack: 'Ad',
                data: series[el].map(el => el.count),
                showBackground: false,
                color:this.colorList[i],
                backgroundStyle: {
                    color: 'rgba(180, 180, 180, 0.2)'
                }
            }
        })
        this.myChart.on('click', (params) => {
            console.log(params)
            this.$emit('drilldown', { chart: 'DirectUsers', value: params.name })
        })
        this.option && this.myChart.setOption(this.option);
    }
};
</script>
  
<style scoped>
.chart {
    height: 100vh;
}
</style>
  
<style>
body {
    margin: 0;
}

#direct {
    height: 400px;
}
</style>